import {
  SAVE_REPORT_DRAFT,
  SAVE_REPORT_DRAFT_SUCCESS,
  SAVE_REPORT_DRAFT_FAILURE,
  FETCH_REPORT_DRAFT,
  FETCH_REPORT_DRAFT_SUCCESS,
  FETCH_REPORT_DRAFT_FAILURE,
  FETCH_REPORT_DRAFT_VERSIONS,
  FETCH_REPORT_DRAFT_VERSIONS_SUCCESS,
  FETCH_REPORT_DRAFT_VERSIONS_FAILURE,
  CLEAR_REPORT_DRAFT,
  CLEAR_SAVE_DRAFT_STATUS
} from './types';

const initialState = {
  // Current draft data (formData)
  draft: null,
  // Signatures stored separately
  draftSignatures: null,
  // Draft metadata
  draftId: null,
  version: null,
  status: null,
  createdAt: null,
  updatedAt: null,
  isReadyToGenerate: false,
  missingFields: [],
  
  // Loading states
  isFetchingDraft: false,
  isSavingDraft: false,
  
  // Error states
  fetchDraftError: null,
  saveDraftError: null,
  
  // Success states
  saveDraftSuccess: false,
  
  // Draft versions
  draftVersions: [],
  isFetchingVersions: false,
  fetchVersionsError: null
};

const reportDraftsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Save Draft
    case SAVE_REPORT_DRAFT:
      return {
        ...state,
        isSavingDraft: true,
        saveDraftError: null,
        saveDraftSuccess: false
      };
    
    case SAVE_REPORT_DRAFT_SUCCESS:
      return {
        ...state,
        isSavingDraft: false,
        saveDraftSuccess: true,
        saveDraftError: null,
        draftId: action.payload?.draftId || state.draftId,
        version: action.payload?.version || state.version,
        isReadyToGenerate: action.payload?.isReadyToGenerate || false,
        missingFields: action.payload?.missingFields || [],
        draft: action.payload?.draft || state.draft
      };
    
    case SAVE_REPORT_DRAFT_FAILURE:
      return {
        ...state,
        isSavingDraft: false,
        saveDraftSuccess: false,
        saveDraftError: action.error
      };

    // Fetch Draft
    case FETCH_REPORT_DRAFT:
      // Clear previous draft immediately so another report type (e.g. Coating vs Welding) cannot show stale data while loading
      return {
        ...state,
        isFetchingDraft: true,
        fetchDraftError: null,
        draft: null,
        draftSignatures: null,
        draftId: null,
        version: null,
        status: null,
        createdAt: null,
        updatedAt: null,
        isReadyToGenerate: false,
        missingFields: [],
      };
    
    case FETCH_REPORT_DRAFT_SUCCESS:
      return {
        ...state,
        isFetchingDraft: false,
        fetchDraftError: null,
        draft: action.payload?.draft || null,
        draftSignatures: action.payload?.draftSignatures || null,
        draftId: action.payload?.draftId || null,
        version: action.payload?.version || null,
        status: action.payload?.status || null,
        createdAt: action.payload?.createdAt || null,
        updatedAt: action.payload?.updatedAt || null,
        isReadyToGenerate: action.payload?.isReadyToGenerate || false,
        missingFields: action.payload?.missingFields || []
      };
    
    case FETCH_REPORT_DRAFT_FAILURE:
      return {
        ...state,
        isFetchingDraft: false,
        fetchDraftError: action.error,
        draft: null
      };

    // Fetch Draft Versions
    case FETCH_REPORT_DRAFT_VERSIONS:
      return {
        ...state,
        isFetchingVersions: true,
        fetchVersionsError: null
      };
    
    case FETCH_REPORT_DRAFT_VERSIONS_SUCCESS:
      return {
        ...state,
        isFetchingVersions: false,
        fetchVersionsError: null,
        draftVersions: action.payload || []
      };
    
    case FETCH_REPORT_DRAFT_VERSIONS_FAILURE:
      return {
        ...state,
        isFetchingVersions: false,
        fetchVersionsError: action.error,
        draftVersions: []
      };

    // Clear Actions
    case CLEAR_REPORT_DRAFT:
      return initialState;
    
    case CLEAR_SAVE_DRAFT_STATUS:
      return {
        ...state,
        saveDraftSuccess: false,
        saveDraftError: null
      };

    default:
      return state;
  }
};

export default reportDraftsReducer;

